import React from "react";
import PageLoader from "../components/PageLoader/PageLoader";

import HeaderOne from "../components/Header/HeaderOne";
import FooterOne from "../components/Footer/FooterOne";
import BlogBreadcrumb from "../components/BlogBreadcrumb/BlogBreadcrumb";


const LayoutBlog = (props) => {
  return (
    <div>
      <PageLoader />

      <HeaderOne />

      <main>
        {/* <BlogBreadcrumb title={props.pageTitle} item={props.item} /> */}

        <section className="blog-area pt-130 pb-130">
          <div className="container">

            <div className="d-lg-flex justify-content-lg-between">{props.children}</div>

            {/* <div className="col-lg-4">
                <BlogAside />
              </div> */}

          </div>
        </section>
      </main>

      <FooterOne />
    </div>
  );
};

export default LayoutBlog;
